import { Tr, Td, HStack, VStack, Box, Stack, Button, Image, Icon } from '@chakra-ui/react';
import { Fragment } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useGetImageUrl } from 'src/hooks';
import { Restaurant } from 'src/utils/__generated__/graphql';

export const RestaurantListItem = ({ restaurant }: { restaurant: Restaurant }) => {
  const { imageUrl: logoUrl } = useGetImageUrl(restaurant?.image);

  return (
    <Fragment>
      <Tr _hover={{ bg: 'gray.50' }}>
        <Td display={{ base: 'none', md: 'table-cell' }}>
          <HStack>
            <Image src={logoUrl || '/assets/img/logo-placeholder.jpg'} alt={restaurant.name} boxSize="80px" />
          </HStack>
        </Td>
        <Td>
          <VStack align="start" spacing={0} pl={{ base: 2, md: 0 }}>
            <Box fontWeight="bold" fontSize="lg">
              {restaurant.name}
            </Box>
            <Box fontWeight="medium" fontSize="sm" color={'gray.500'}>
              {restaurant.address}
            </Box>
          </VStack>
        </Td>
        <Td display={{ base: 'none', md: 'table-cell' }} fontSize="sm">
          {restaurant.phone}
        </Td>

        <Td display={{ base: 'none', md: 'table-cell' }} fontSize="sm">
          {restaurant.email}
        </Td>
        <Td display={{ base: 'none', md: 'table-cell' }} fontSize="sm">
          {restaurant.admin_commission}
        </Td>
        <Td display={{ base: 'none', md: 'table-cell' }} fontSize="sm">
          {restaurant.delivery_commission}
        </Td>

        <Td display={{ base: 'none', md: 'table-cell' }} fontSize="sm">
          {restaurant.isActive ? (
            <Icon as={FaCheckCircle as any} color="teal" boxSize={4} />
          ) : (
            <Icon as={FaTimesCircle as any} color="gray" boxSize={4} />
          )}
        </Td>

        <Td>
          <Stack direction={{ base: 'column', md: 'row' }} fontSize={{ base: 'sm', md: 'md' }} alignItems="center">
            {[{ label: 'Edit', url: `/admin/edit-restaurant/${restaurant.id}` }].map((item, index) => (
              <RestaurantSettingLink key={index} link={item.url} label={item.label} />
            ))}
          </Stack>
        </Td>
      </Tr>
    </Fragment>
  );
};

const RestaurantSettingLink = ({ link, label }: { link: string; label: string }) => {
  return (
    <Link to={link}>
      <Button colorScheme="teal" variant="ghost">
        {label}
      </Button>
    </Link>
  );
};
